import {
  preFooterTextPost,
  preFooterTextPre,
} from "../../../../types/global.types";

const FooterText = ({
  displayOnly,
  footerText,
  hasTooltip = false,
  mobile = false,
}: {
  displayOnly: boolean;
  footerText?: string;
  hasTooltip?: boolean;
  mobile?: boolean;
}) => {
  if (footerText === preFooterTextPost || footerText === preFooterTextPre) {
    footerText = "";
  }

  return (
    <span
      tabIndex={0}
      role="contentinfo"
      aria-label={
        footerText
          ? footerText
          : displayOnly
          ? preFooterTextPre
          : preFooterTextPost
      }
    >
      {footerText
        ? footerText.length > 75 && (hasTooltip || mobile)
          ? footerText.slice(0, 75) + "..."
          : footerText
        : displayOnly
        ? preFooterTextPre
        : (hasTooltip || mobile) && preFooterTextPost.length > 75
        ? preFooterTextPost.slice(0, 75) + "..."
        : preFooterTextPost}
      {(hasTooltip || mobile) && (
        <span className="preview-tooltip">
          {footerText
            ? footerText
            : displayOnly
            ? preFooterTextPre
            : preFooterTextPost}
        </span>
      )}
    </span>
  );
};

export default FooterText;
